export default "__VITE_ASSET__DTFF3iTP__"